<template>
    <div class="about__section">
        <h3>{{ l('ABOUT.CONNECTION_HEADING') }}</h3>
        <dl>
            <dt>{{ l('ABOUT.CONNECTION_STATUS') }}</dt>
            <dd>
                <template v-if="isOnline === null">
                    <i class="fa-solid fa-wifi"></i> {{ l('ABOUT.CONNECTION_CHECKING') }}
                </template>
                <template v-else-if="isOnline === true">
                    <i class="fa-solid fa-wifi"></i> {{ l('ABOUT.CONNECTION_ONLINE') }}
                </template>
                <template v-else-if="isOnline === false">
                    <i class="fa-solid fa-wifi-slash"></i> {{ l('ABOUT.CONNECTION_OFFLINE') }}
                </template>
            </dd>

            <dt></dt>
            <dd>
                <button class="btn btn-default btn-sm"
                        @click="checkConnectivity()">
                    {{ l('ABOUT.CHECK') }}
                    <i v-if="checkingConnectivity"
                       class="fa-solid fa-spinner fa-spin"></i>
                </button>
            </dd>
        </dl>
    </div>
</template>

<script>
import { container } from '@/container';

export default {
    name: 'AboutConnectionSection',

    data() {
        return {
            isOnline: null,
            checkingConnectivity: false,
        };
    },

    created() {
        this.checkConnectivity();
    },

    methods: {
        checkConnectivity() {
            this.checkingConnectivity = true;
            this.isOnline = null;
            container.connectivityChecker
                .check()
                .then((isOnline) => {
                    this.isOnline = isOnline;
                })
                .catch(() => {
                    this.isOnline = false;
                })
                .finally(() => {
                    this.checkingConnectivity = false;
                });
        },
    },
};
</script>
